export default {
  welcomeUser: "Welcome {{name}} ({{role}})",
  selectOption: "select the desired option",
  closeMessage: "Close message",
  mode: {
    operateAs: "Operate as",
    professional: "Professional",
    patient: "Patient",
  },
  unreadMessages: "{{count}} unread messages",
  inventoryReorder: "You have supplies to restock",
  inventoryExpiring: "You have supplies about to expire",
  inventoryReorderAndExpiring: "You have supplies to restock and about to expire",
  pendingValidation:
    "Your professional account is pending validation. Go to Settings, complete your profile including front and back ID photos, and subscribe for a 15-day free trial. Once administration validates your information, you will receive a message to operate freely.",
  comingSoonNotifications:
    "Coming soon: send messages to all your patients via WhatsApp or Email with one click!",
  comingSoonClinicalHistory:
    "Coming soon. We are improving the experience.",
  nav: {
    configureSchedule: "Configure Schedule",
    viewAppointments: "View Appointments",
    assignAppointments: "Assign Appointments",
    shareSchedules: "Share Schedules",
    clinicalHistory: "Clinical Records",
    inventory: "Inventory",
    waitingRoom: "Patient Reception",
    notifications: "Notifications",
    informedConsent: "Informed Consent",
    sharedSchedules: "Appointments & Shared Schedules",
    institutionSchedules: "Shared Schedules",
    messaging: "Messaging",
    administration: "Administration",
    bookAppointment: "Book Appointment",
    myAppointments: "My Appointments",
    bookAsPatient: "Book Appointment (as patient)",
    myAppointmentsAsPatient: "My Appointments (as patient)",
    myStudies: "My Studies",
  },
};
